import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '35px'
  },
  bookingDetails: {
    width: '600px'
  },
  doneIcon: {
    color: '#0D7AA1',
    fontSize: '22px',
    marginRight: '10px'
  },
  bookingNumber: {
    display: 'contents',
    fontWeight: 'bold',
    textTransform: 'uppercase'
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    color: '#071B27',
    marginBottom: '20px',
    fontWeight: 'normal'
  },
  bookingTitle: {
    color: '#071B27',
    textTransform: 'uppercase',
    marginBottom: '15px',
    letterSpacing: '0.05em'
  },
  loaderClassName: {
    width: '80px !important',
    height: '80px !important'
  },
  loaderWrapper: {
    position: 'fixed'
  }
});

export default useStyles;
